import React from 'react';
import Map from '../../common/mapComponent';
import { Collapse } from 'reactstrap';
import { Translate } from 'react-localize-redux';
import { bindActionCreators } from 'redux';
import { reportActions } from '../../../store/reportStore'
import { connect } from 'react-redux';
import HistoryLink from '../../common/historyLink';
import CustomTooltip from "../../common/customTooltip";

class AddressRow extends React.Component {

    state = { addrHistoryExpanded: false, isAddrHistoryExpandedTouched: false }

    componentDidUpdate(prevProps) {
        if (this.props.isExpandAllActivated !== prevProps.isExpandAllActivated || this.props.isHideAllActivated !== prevProps.isHideAllActivated) {
            this.setState({ isAddrHistoryExpandedTouched: false });
        }
    }

    render() { 
        return (
            <div className='ident-item' >
            <span className="bold">
                {this.props.group.header}
            </span>
            <span>
                <span style={{display: "block"}}>
                {this.getActiveAddresses(this.props.group.addresses).map(address => <React.Fragment key={address.rowId}><span>
                    <span>{address.fullAddress}</span>
                    &nbsp;
                    <Map id={address.rowId} address={address.fullAddress} />
                    <i className="src" id={"rowId"+address.rowId} style={{ float: "right" }}>(<Translate id="Report.Common.Source" />&nbsp;{address.source})
                    <CustomTooltip textAlign="right" placement='left' id={"rowId" + address.rowId} text={address.SourceFull} hideIcon delay={{ "show": 0, "hide": 0 }} innerClassName='tooltipSection'>
                    </CustomTooltip>
                    </i>
                </span><br /></React.Fragment>)}
                </span>

                {this.props.group.addresses.some(addr => addr.endDate) &&
                    <span onClick={this.toggleAddressHistory} className="link-functional link-left print-hidden">
                        <HistoryLink noWrapper historyExpanded={this.props.resolveExpanded(this.state.addrHistoryExpanded, this.state.isAddrHistoryExpandedTouched)} />
                    </span>
                }
                {this.props.group.addresses.some(addr => addr.endDate) && this.renderAddressHistory(this.props.group.addresses.filter(addr => addr.endDate), this.props.group.header.replace(/ /g,''))}
            </span>
        </div>
    );}

    renderAddressHistory = (values, groupId) => {
        return (
            <Collapse isOpen={this.props.resolveExpanded(this.state.addrHistoryExpanded, this.state.isAddrHistoryExpandedTouched)} >
                {values.map((v, i) =>
                    <div className="contact-address-history" style={{ display: "flex", fontStyle: "italic" }} key={i}>
                        <span>
                            <span>{v.fullAddress}</span>
                            &nbsp;
                            <span className="src">(
                                <Translate id="Report.Common.From" />&nbsp;
                                {v.startDateFormated}&nbsp;
                                <Translate id="Report.Common.To" />&nbsp;{v.endDateFormated}
                                )
                            </span>
                        </span>
                        <span className="src" id={groupId + "-"+i} style={{ whiteSpace: "nowrap", alignSelf: "flex-end", marginLeft: "auto" }}>
                            (<Translate id="Report.Common.Source" />:&nbsp;{v.source})
                            <CustomTooltip textAlign="right" placement='left' id={groupId + "-"+i} text={v.SourceFull} hideIcon delay={{ "show": 0, "hide": 0 }} innerClassName='tooltipSection'>
                            </CustomTooltip>
                        </span>
                    </div>
                )}
            </Collapse>
        );
    }

    toggleAddressHistory = () => {
        this.setState({
            addrHistoryExpanded: !this.props.resolveExpanded(this.state.addrHistoryExpanded, this.state.isAddrHistoryExpandedTouched),
            isAddrHistoryExpandedTouched: true
        });
    }

    getActiveAddresses = addresses => addresses.filter(addr => !addr.endDate);
}

export default connect(state => ({}), dispatch => bindActionCreators(reportActions, dispatch))(AddressRow);